import util from "@/utils/util";
// console.log('8888888888888888',util);

export const publicData = {
  // logo:require("@/assets/img/logo.png"),

  projectName: "支付页面",
  getComArgs:
    process.env.NODE_ENV === "development" || util.getUrlQueryString("testId")
      ? // process.env.NODE_ENV === "development"
        "token=125&udid=125&productId=ded16d09-d7f0-4044-a21a-723e7ae88e45&vestId=dcc824e6-213c-4f18-937d-36680b554158&channel=test&osType=android&version=1"
      : "",
  payList: [
    {
      payMode: "alipay",
      payType: 1, // 新增
      supportFlag: true,
      defaultPayFlag: false,
    },
    {
      payMode: "weChat",
      payType: 2, // 新增
      supportFlag: true,
      defaultPayFlag: true,
    },
  ],
};
